import moment from 'moment'
import Vue from 'vue'

// const { locale } = store.state.global
// moment.locale(locale)
Vue.prototype.$moment = moment
